import React from "react"
import { motion } from "framer-motion"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast"
import { useToast } from "../../hooks/use-toast"
import { AnimatedList } from "./animated-list"

export function Toaster() {
  const { toasts } = useToast()
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;

  return (
    <ToastProvider>
      <div className="fixed top-4 sm:top-8 left-1/2 transform -translate-x-1/2 z-[100] w-[calc(100vw-2rem)] sm:w-full max-w-md pointer-events-none">
        <AnimatedList className="gap-3" delay={100}>
          {toasts.map(({ id, title, description, action, variant, ...props }) => (
            <ToastItem
              key={id}
              id={id}
              title={title}
              description={description}
              action={action}
              variant={variant}
              isMobile={isMobile}
              onDismiss={() => {
                const toast = toasts.find(t => t.id === id);
                if (toast?.onOpenChange) {
                  toast.onOpenChange(false);
                }
              }}
              {...props}
            />
          ))}
        </AnimatedList>
      </div>
      <ToastViewport />
    </ToastProvider>
  )
}

// 单独的Toast项组件，使代码更清晰
function ToastItem({ id, title, description, action, variant, isMobile, onDismiss, ...props }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8, y: -50 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.8, y: -50 }}
      whileHover={!isMobile ? { scale: 1.02, y: -2 } : {}}
      whileTap={isMobile ? { scale: 0.98 } : {}}
      drag={isMobile ? "x" : false}
      dragConstraints={{ left: -100, right: 100 }}
      dragElastic={0.2}
      onDragEnd={(event, info) => {
        // 滑动关闭
        if (Math.abs(info.offset.x) > 50) {
          onDismiss();
        }
      }}
      className="w-full pointer-events-auto"
    >
      <Toast variant={variant} {...props}>
        <div className="flex-1 space-y-1">
          {title && (
            <motion.div
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.3 }}
            >
              <ToastTitle>{title}</ToastTitle>
            </motion.div>
          )}
          {description && (
            <motion.div
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3, duration: 0.3 }}
            >
              <ToastDescription>{description}</ToastDescription>
            </motion.div>
          )}
        </div>
        {action}
        <ToastClose />
      </Toast>
    </motion.div>
  );
} 